<template>
  <div class="reference-settings-page">
    <div>
      <div>
        <vx-card class="no-scroll-content" title="References">
          <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <vs-tabs
                v-model="activeTab"
                class="tab-action-btn-fill-container"
                position="left"
              >
                <vs-tab
                  label="Type Of Earnings"
                  icon-pack="feather"
                  icon="icon-plus"
                >
                  <div class="tab-text">
                    <earnings-type />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Earnings Category"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <EarningsCategory />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Type Of Deductions"
                  icon-pack="feather"
                  icon="icon-minus"
                >
                  <div class="tab-text">
                    <deductions-type />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Deductions Category"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <DeductionsCategory />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Overtime Type"
                  icon-pack="feather"
                  icon="icon-file"
                >
                  <div class="tab-text">
                    <OvertimeType />
                  </div>
                </vs-tab>

                <!-- Payroll doesn't want to see this tab for now, so commenting out. Can be added back later if needed. 
                <vs-tab label="Loan Name" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <LoanName />
                  </div>
                </vs-tab> 

                <vs-tab label="Loan Type" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <LoanType />
                  </div>
                </vs-tab>
                -->
                <vs-tab
                  label="Loan Category"
                  icon-pack="feather"
                  icon="icon-file-minus"
                >
                  <div class="tab-text">
                    <LoanCategory />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Loans Sub-Category"
                  icon-pack="feather"
                  icon="icon-file-minus"
                >
                  <div class="tab-text">
                    <loan-sub-category />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Accreditation Type"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <AccreditationType />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Appraisal Type"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <AppraisalType />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Appraisal Rating"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <AppraisalRating />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Association"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <Association />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Area of Study"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <AreaofStudy />
                  </div>
                </vs-tab>

                <vs-tab label="Award" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Award />
                  </div>
                </vs-tab>

                <vs-tab label="Bank Data" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <BankData />
                  </div>
                </vs-tab>

                <vs-tab
                  label="BenefitType"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <BenefitType />
                  </div>
                </vs-tab>

                <vs-tab label="Branch" icon-pack="feather" icon="icon-file">
                  <div class="tab-text">
                    <Branch />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Civil Status"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <CivilStatus />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Claim Category"
                  icon-pack="feather"
                  icon="icon-file"
                >
                  <div class="tab-text">
                    <ClaimCategory />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Claim Sub Category"
                  icon-pack="feather"
                  icon="icon-file"
                >
                  <div class="tab-text">
                    <claim-sub-category />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Create Payroll Type"
                  icon-pack="feather"
                  icon="icon-dollar-sign"
                >
                  <div class="tab-text">
                    <CreatePayrollType />
                  </div>
                </vs-tab>

                <vs-tab label="Degree" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Degree />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Department Type"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <DepartmentType />
                  </div>
                </vs-tab>

                <vs-tab label="Division" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Division />
                  </div>
                </vs-tab>
                <vs-tab
                  label="Employee Category"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <EmployeeCategory />
                  </div>
                </vs-tab>

                <vs-tab label="Leave Type" icon-pack="feather" icon="icon-file">
                  <div class="tab-text">
                    <LeaveType />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Line of Business"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <LineofBusiness />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Market Segment"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <MarketSegment />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Medical Procedure"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <MedicalProcedure />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Nationality"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <Nationality />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Payment Mode"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <PaymentMode />
                  </div>
                </vs-tab>

                <vs-tab label="Period" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Period />
                  </div>
                </vs-tab>

                <vs-tab label="Position" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Position />
                  </div>
                </vs-tab>

                <vs-tab label="Rank" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Rank />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Relationship"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <Relationship />
                  </div>
                </vs-tab>

                <vs-tab label="Religion" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Religion />
                  </div>
                </vs-tab>
                <vs-tab
                  label="Salary Based On"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <SalaryBasedOn />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Schedule Number"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <ScheduleNumber />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Schedule Type"
                  icon-pack="feather"
                  icon="icon-file"
                >
                  <div class="tab-text">
                    <ScheduleType />
                  </div>
                </vs-tab>

                <vs-tab label="Section" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <SectionLookup />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Segment Type"
                  icon-pack="feather"
                  icon="icon-file"
                >
                  <div class="tab-text">
                    <SegmentType />
                  </div>
                </vs-tab>

                <vs-tab label="Shift Type" icon-pack="feather" icon="icon-file">
                  <div class="tab-text">
                    <ShiftType />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Tax Reference"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <TaxReference />
                  </div>
                </vs-tab>

                <vs-tab label="Violation" icon-pack="feather" icon="icon-users">
                  <div class="tab-text">
                    <Violation />
                  </div>
                </vs-tab>

                <vs-tab
                  label="Violation Action"
                  icon-pack="feather"
                  icon="icon-users"
                >
                  <div class="tab-text">
                    <ViolationAction />
                  </div>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import EarningsType from "./settings/references/EarningsType.vue";
import DeductionsType from "./settings/references/DeductionsType.vue";
import LoanSubCategory from "./settings/references/LoanSubCategory.vue";
import "flatpickr/dist/flatpickr.css";
import LeaveType from "./settings/references/LeaveType.vue";
import ShiftType from "./settings/references/ShiftType.vue";
import ScheduleType from "./settings/references/ScheduleType.vue";
import SegmentType from "./settings/references/SegmentType.vue";
import OvertimeType from "./settings/references/OvertimeType.vue";
import DepartmentType from "./settings/references/DepartmentType.vue";
import LoanCategory from "./settings/references/LoanCategory.vue";
import ClaimCategory from "./settings/references/ClaimCategory.vue";
import ClaimSubCategory from "./settings/references/ClaimSubCategory.vue";
import Branch from "./settings/references/Branch.vue";
import CreatePayrollType from "./settings/references/CreatePayrollType.vue";
import Position from "./settings/references/Position.vue";
import Division from "./settings/references/Division.vue";
import SectionLookup from "./settings/references/SectionLookup.vue";
import EmployeeCategory from "./settings/references/EmployeeCategory.vue";
import EarningsCategory from "./settings/references/EarningsCategory.vue";
import DeductionsCategory from "./settings/references/DeductionsCategory.vue";
// import LoanType from "./settings/references/LoanType.vue";
// import LoanName from "./settings/references/LoanName.vue";
import CivilStatus from "./settings/references/CivilStatus.vue";
import Nationality from "./settings/references/Nationality.vue";
import Religion from "./settings/references/Religion.vue";
import Relationship from "./settings/references/Relationship.vue";
import AccreditationType from "./settings/references/AccreditationType.vue";
import Association from "./settings/references/Association.vue";
import BankData from "./settings/references/BankData.vue";
import Period from "./settings/references/Period.vue";
import BenefitType from "./settings/references/BenefitType.vue";
import Rank from "./settings/references/Rank.vue";
import LineofBusiness from "./settings/references/LineofBusiness.vue";
import Degree from "./settings/references/Degree.vue";
import AreaofStudy from "./settings/references/AreaofStudy.vue";
// import Institution from "./settings/references/Institution.vue";
import Award from "./settings/references/Award.vue";
import MedicalProcedure from "./settings/references/MedicalProcedure.vue";
import AppraisalType from "./settings/references/AppraisalType.vue";
import MarketSegment from "./settings/references/MarketSegment.vue";
import AppraisalRating from "./settings/references/AppraisalRating.vue";
import PaymentMode from "./settings/references/PaymentMode.vue";
import SalaryBasedOn from "./settings/references/SalaryBasedOn.vue";
import ScheduleNumber from "./settings/references/ScheduleNumber.vue";
import TaxReference from "./settings/references/TaxReference.vue";
import Violation from "./settings/references/Violation.vue";
import ViolationAction from "./settings/references/ViolationAction.vue";

export default {
  data() {
    return {
      activeTab: 0,
    };
  },
  components: {
    EarningsType,
    DeductionsType,
    LoanSubCategory,
    LeaveType,
    ShiftType,
    ScheduleType,
    SegmentType,
    OvertimeType,
    DepartmentType,
    LoanCategory,
    ClaimCategory,
    ClaimSubCategory,
    Branch,
    CreatePayrollType,
    Position,
    Division,
    SectionLookup,
    EmployeeCategory,
    EarningsCategory,
    DeductionsCategory,
    // LoanType,
    // LoanName,
    CivilStatus,
    Nationality,
    Religion,
    Relationship,
    AccreditationType,
    Association,
    BankData,
    Period,
    BenefitType,
    Rank,
    LineofBusiness,
    Degree,
    AreaofStudy,
    // Institution,
    Award,
    MedicalProcedure,
    AppraisalType,
    MarketSegment,
    AppraisalRating,
    PaymentMode,
    SalaryBasedOn,
    ScheduleNumber,
    TaxReference,
    Violation,
    ViolationAction,
  },
};
</script>

<style>
.reference-settings-page .con-ul-tabs {
  height: 70vh !important;
  width: 15vw !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
</style>
